<template>
    <div class="light-color-bg position-relative justify-full-heigh">
        <HeaderMain title="Organisation" description="Choisissez votre domaine d'activité."></HeaderMain>
        <div class="container-70">
            <SelectOptionBox :img="imgAlimentation" :options="options" v-model="result"
                @update:modelValue="changeNext()"></SelectOptionBox>
            <div v-if="result != null" @click="saveAndContinue('organisationType', JSON.stringify(result), nextPage)"
                class="btn-primary d-block w-100 mt-50px text-center">Suivant</div>
        </div>
        <div></div>
        <div class="container-70">
            <div class="come-back mt-50px" @click="$router.back()">
                <CustomIcon name="chevron-left"></CustomIcon>Question précédente
            </div>
        </div>
    </div>
</template>
<script>
import HeaderMain from '@/components/HeaderMain.vue'
import SelectOptionBox from '@/components/SelectOptionBox.vue'
import CustomIcon from '../../components/CustomIcon.vue'
/*Mixins*/
import utils from '@/mixins/utils'
export default {
    data() {
        return {
            result: null,
            imgAlimentation: require('@/assets/images/organisation_type.png'),
            options: [
                {
                    label: "Commerce de gros",
                    value: "Commerce de gros",
                    factor: 32.0806
                },
                {
                    label: "Commerce de détail",
                    value: "Commerce de détail",
                    factor: 34.3666,
                },
                {
                    label: "Transport et entreposage",
                    value: "Transport et entreposage",
                    factor: 27.9975,
                },
                {
                    label: "Industrie de l'information et culturelle",
                    value: "Industrie de l'information et culturelle",
                    factor: 47.5266
                },
                {
                    label: "Entreprise de services qui occupe des bureaux",
                    value: "Entreprise de services qui occupe des bureaux",
                    factor: 19.9526
                },
                {
                    label: "Établissement d'enseignement",
                    value: "Établissement d'enseignement",
                    factor: 35.1891
                },
                {
                    label: "Santé et assistance sociale",
                    value: "Santé et assistance sociale",
                    factor: 69.2832
                },
                {
                    label: "Arts, spectacles et loisirs",
                    value: "Arts, spectacles et loisirs",
                    factor: 40.0433
                },
                {
                    label: "Restauration",
                    value: "Restauration",
                    factor: 57.1273
                },
                {
                    label: "Construction",
                    value: "Construction",
                    factor: 8.5
                },
                {
                    label: "Domaine d'activité autre",
                    value: "Domaine d'activité autre",
                    factor:null
                }
            ],
            nextPage: './choix-calcul'
        }
    },
    components: {
        HeaderMain,
        CustomIcon,
        SelectOptionBox
    },
    mixins: [utils],
    mounted() {
        this.changeNext()
        if (sessionStorage.getItem('organisationType')) {
            this.result = JSON.parse(sessionStorage.getItem('organisationType'))
        }
    },
    methods: {
        changeNext() {
            if(this.result){
                if ( this.result.value === "Domaine d'activité autre") {
                this.nextPage = '/questionnaire/organisation/detaille/question-1'
                sessionStorage.setItem('formType', 'detaillee');
                }
                else {
                    this.nextPage = './choix-calcul'
                    this.result.factor=this.options.find(element=>element.label===this.result.value).factor
                }
            }
        }
    }
}
</script>